import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login.vue'
import Main from '@/views/Main.vue'
import metrika from '@/views/metrika'
import albums_index from '@/views/albums/index'
import photo_albums_edit from '@/views/albums/photo/edit'
import photo_albums_index from '@/views/albums/photo/index'
import photo_albums_create from '@/views/albums/photo/create'
import video_albums_index from '@/views/albums/video/index'
import video_albums_create_edit from '@/views/albums/video/create_edit'

import articles_create_edit from '@/views/articles/create_edit'
import articles_index from '@/views/articles/index'
import UserList from '@/views/users/UserList'
import UserCreate from '@/views/users/UserCreateUpdate'
import sites from '@/views/sites/sites'
import SiteDetail from '@/views/sites/SiteDetail'
import newspapers_index from '@/views/press/newspapers/index'
import create_update from '@/views/press/newspapers/create_update'

import party from '@/views/party/index'
import history from '@/views/party/history/index'
import program from '@/views/party/program/index'
import members_index from '@/views/members/index'
import members_list from '@/views/members/members/list'
import members_create_edit from '@/views/members/members/create_edit'
import groups_list from '@/views/members/groups/index'
import groups_create_edit from '@/views/members/groups/create_edit'

import press_index from '@/views/press/index'
import brochures_list from '@/views/press/brochures/index'
import brochures_edit from '@/views/press/brochures/create_update'
import magazines_index from '@/views/press/magazines/index'
import magazines_edit from '@/views/press/magazines/create_update'
import program_article_index from '@/views/press/program_article/index'
import program_article_edit from '@/views/press/program_article/create_update'

import banner_index from '@/views/banners/index'
import banner_list from '@/views/banners/list'
import banner_create_edit from '@/views/banners/create_edit'

import tags_index from '@/views/tags/index'
import documents_index from '@/views/documents/index'
import documents_created_edit from '@/views/documents/create_edit'
import axios from 'axios'

import playlist_index from '@/views/playlists/index'
import playlist_create_edit from '@/views/playlists/create_edit'

import hps_about_create_edit from '@/views/hps/about/create_edit'
import hps_contacts_create_edit from '@/views/hps/contacts/create_edit'
import hps_index from '@/views/hps/index'
import hps_hps_index from '@/views/hps/courses/index'
import hps_teachers_index from '@/views/hps/courses/teachers/index'
import hps_teachers_create_edit from '@/views/hps/courses/teachers/create_edit'
import hps_courses_index from '@/views/hps/courses/courses/index'
import hps_courses_create_edit from '@/views/hps/courses/courses/create_edit'
import hps_lectures_create_edit from '@/views/hps/courses/courses/lectures/edit'
import references_position_events from '@/views/references/position_events'
import references_listener_course from '@/views/references/listener_course'
import references_sites_posts from '@/views/references/sites_posts'
import push_notifications from '@/views/notifications/push_notifications'
import activist_index from '@/views/activist/index'
import activist_task_index from '@/views/activist/tasks/index'
import activist_task_create_edit from '@/views/activist/tasks/create_edit'
import activist_taken_task_list from '@/views/activist/tasks/taken_task_list'
import activist_taken_task_detail from '@/views/activist/tasks/taken_task_detail'
import activist_metrics_index from '@/views/activist/metrics/index'
import activist_metrics_counts_table from '@/views/activist/metrics/counts_table'

// integration
import integrations_index from '@/views/integrations/index'
import vk_groups_index from '@/views/integrations/vk/index'
import vk_groups_create_edit from '@/views/integrations/vk/create_edit_group'

import faq_view from '@/views/faq/index'
import yasldpr from '@/views/yasldpr/index'
import vstupi from '@/views/vstupi/index.vue'

Vue.use(Router)

const ifNotAuthenticated = (to, from, next) => {
  if (!localStorage.getItem('user-token')) {
    next()
    return
  }
  next('/login')
}

const ifAuthenticated = (to, from, next) => {
  if (localStorage.getItem('user-token')) {
    next()
    return
  }
  next({
    path: '/login',
    query: {
      nextUrl: to.fullPath,
    },
  })
}

const getMe = async (to, from, next) => {
  try {
    await axios.get('/v1/users/me')
    next()
  } catch (err) {
    next({
      path: '/login',
      query: {
        nextUrl: to.fullPath,
      },
    })
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  beforeEach: (to, from, next) => {
    getMe(to, from, next)
    if (to.name !== 'login' || from.name !== 'login') {
      ifNotAuthenticated(to, from, next)
    }
    to.params.site_key = localStorage.getItem('user-region')
    to.query.site_key = localStorage.getItem('user-region')
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/',
      name: 'main',
      component: Main,
      beforeEnter: getMe,
      children: [
        {
          path: 'hps',
          name: 'hps',
          component: hps_index,
          beforeEnter: getMe,
        },
        {
          path: 'hps/about',
          name: 'hps_about',
          beforeEnter: getMe,
          components: { main_content: hps_about_create_edit },
        },
        {
          path: 'hps/contacts',
          name: 'hps_contacts',
          beforeEnter: getMe,
          components: { main_content: hps_contacts_create_edit },
        },
        {
          path: 'hps/courses',
          name: 'hps_courses',
          beforeEnter: getMe,
          components: { main_content: hps_hps_index, hps_courses: hps_courses_index },
          children: [
            {
              path: '',
              beforeEnter: getMe,
              components: {
                main_content: hps_hps_index,
                hps_courses: hps_courses_index,
              },
            },
            {
              path: 'teacher',
              name: 'hps_teacher',
              beforeEnter: getMe,
              components: { hps_courses: hps_teachers_index },
            },
            {
              path: 'teacher/create',
              name: 'hps_teacher_create',
              beforeEnter: getMe,
              components: { hps_courses: hps_teachers_create_edit },
            },
            {
              path: 'teacher/:id',
              name: 'hps_teacher_edit',
              beforeEnter: getMe,
              components: { hps_courses: hps_teachers_create_edit },
            },
            {
              path: 'course',
              name: 'hps_course',
              beforeEnter: getMe,
              components: { hps_courses: hps_courses_index },
            },
            {
              path: 'course/create',
              name: 'hps_course_create',
              beforeEnter: getMe,
              components: { hps_courses: hps_courses_create_edit },
            },
            {
              path: 'course/:id',
              name: 'hps_course_edit',
              beforeEnter: getMe,
              components: { hps_courses: hps_courses_create_edit },
            },
            {
              path: 'lecture/:id',
              name: 'hps_lecture_edit',
              beforeEnter: getMe,
              components: { hps_courses: hps_lectures_create_edit },
            },
          ],
        },
        {
          path: 'integrations',
          name: 'integrations',
          beforeEnter: getMe,
          components: { main_content: integrations_index, integrations: vk_groups_index },
          children: [
            {
              path: '',
              beforeEnter: getMe,
              components: {
                main_content: integrations_index,
                hps_courses: vk_groups_index,
              },
            },
            {
              path: 'vk',
              name: 'vk_groups',
              beforeEnter: getMe,
              components: {
                integrations: vk_groups_index,
              },
            },
            {
              path: 'vk/group/:id',
              name: 'vk_group_create_edit',
              beforeEnter: getMe,
              components: {
                integrations: vk_groups_create_edit,
              },
            },
          ],
        },
        {
          path: 'activist',
          name: 'activist',
          beforeEnter: getMe,
          components: { main_content: activist_index, activist: activist_task_index },
          children: [
            {
              path: '',
              beforeEnter: getMe,
              components: { main_content: activist_index, activist: activist_task_index },
            },
            {
              path: 'tasks',
              name: 'activist_tasks',
              component: activist_task_index,
              beforeEnter: getMe,
              components: { activist: activist_task_index },
            },
            {
              path: 'tasks/create',
              name: 'activist_task_create',
              component: activist_task_create_edit,
              beforeEnter: getMe,
              components: { activist: activist_task_create_edit },
            },
            {
              path: 'tasks/:id',
              name: 'activist_task_edit',
              component: activist_task_create_edit,
              beforeEnter: getMe,
              components: { activist: activist_task_create_edit },
            },
            {
              path: 'tasks/:task_id/inspect',
              name: 'activist_taken_task_list',
              component: activist_taken_task_list,
              beforeEnter: getMe,
              components: { activist: activist_taken_task_list },
            },
            {
              path: 'tasks/:task_id/inspect/:taken_task_id',
              name: 'activist_taken_task_detail',
              component: activist_taken_task_detail,
              beforeEnter: getMe,
              components: { activist: activist_taken_task_detail },
            },
          ],
        },
        {
          path: 'activist/metrics',
          name: 'activist_metrics',
          beforeEnter: getMe,
          components: {
            main_content: activist_metrics_index,
            activist_metrics: activist_task_index,
          },
          children: [
            {
              path: '',
              beforeEnter: getMe,
              components: {
                main_content: activist_metrics_index,
                activist_metrics: activist_metrics_counts_table,
              },
            },
            {
              path: 'counts',
              name: 'activist_metrics_counts',
              beforeEnter: getMe,
              components: {
                activist_metrics: activist_metrics_counts_table,
              },
            },
          ],
        },
        {
          path: 'metrika',
          name: 'metrika',
          props: (route) => ({ site_key: route.params.site_key }),
          components: {
            main_content: metrika,
          },
        },
        {
          path: 'playlist',
          name: 'playlist',
          props: (route) => ({ site_key: route.params.site_key }),
          beforeEnter: getMe,
          components: { main_content: playlist_index },
        },
        {
          path: 'playlist/create',
          name: 'playlist_create',
          props: (route) => ({ site_key: route.params.site_key }),
          beforeEnter: getMe,
          components: { main_content: playlist_create_edit },
        },
        {
          path: 'playlist/:id',
          name: 'playlist_edit',
          props: (route) => ({ site_key: route.params.site_key }),
          beforeEnter: getMe,
          components: { main_content: playlist_create_edit },
        },
        {
          path: 'documents',
          name: 'documents',
          props: (route) => ({ site_key: route.params.site_key }),
          beforeEnter: getMe,
          components: {
            main_content: documents_index,
          },
        },
        {
          path: 'documents/create',
          name: 'documents_create',
          beforeEnter: getMe,
          components: {
            main_content: documents_created_edit,
          },
        },
        {
          path: 'documents/:id',
          name: 'documents_edit',
          beforeEnter: getMe,
          components: {
            main_content: documents_created_edit,
          },
        },
        {
          path: 'tags',
          name: 'tags',
          beforeEnter: getMe,
          components: {
            default: tags_index,
            main_content: tags_index,
          },
        },
        {
          path: 'albums',
          name: 'albums',
          beforeEnter: getMe,
          props: (route) => ({ site_key: route.params.site_key }),
          components: { main_content: albums_index },
          children: [
            {
              path: '',
              beforeEnter: getMe,
              components: {
                albums: photo_albums_index,
              },
            },
            {
              path: 'photo',
              name: 'photo_albums_list',
              beforeEnter: getMe,
              components: {
                albums: photo_albums_index,
              },
            },
            {
              path: 'photo/create',
              name: 'photo_albums_create',
              beforeEnter: getMe,
              components: {
                albums: photo_albums_create,
              },
            },
            {
              path: 'photo/:id',
              name: 'photo_albums_edit',
              beforeEnter: getMe,
              components: {
                albums: photo_albums_edit,
              },
            },
            {
              path: 'video',
              name: 'video_albums_list',
              beforeEnter: getMe,
              components: {
                albums: video_albums_index,
              },
            },
            {
              path: 'video/create',
              name: 'video_albums_create',
              beforeEnter: getMe,
              components: {
                albums: video_albums_create_edit,
              },
            },
            {
              path: 'video/:id',
              name: 'video_albums_edit',
              beforeEnter: getMe,
              components: {
                albums: video_albums_create_edit,
              },
            },
          ],
        },
        {
          path: 'articles',
          name: 'articles',
          beforeEnter: getMe,
          components: {
            default: articles_index,
            main_content: articles_index,
          },
        },
        {
          path: 'articles/create',
          name: 'article_create',
          beforeEnter: getMe,
          components: {
            default: articles_create_edit,
            main_content: articles_create_edit,
          },
        },
        {
          path: 'articles/:id',
          name: 'article_edit',
          beforeEnter: getMe,
          components: {
            default: articles_create_edit,
            main_content: articles_create_edit,
          },
        },
        {
          path: 'faq',
          name: 'faq',
          beforeEnter: getMe,
          components: {
            default: faq_view,
            main_content: faq_view,
          },
        },
        {
          path: 'users',
          name: 'users',
          beforeEnter: getMe,
          components: {
            default: UserList,
            main_content: UserList,
          },
        },
        {
          path: 'references/events',
          name: 'references-events',
          beforeEnter: getMe,
          components: {
            default: references_position_events,
            main_content: references_position_events,
          },
        },
        {
          path: 'references/courses',
          name: 'references-courses',
          beforeEnter: getMe,
          components: {
            default: references_listener_course,
            main_content: references_listener_course,
          },
        },
        {
          path: 'references/sites',
          name: 'references-sites-posts',
          beforeEnter: getMe,
          components: {
            default: references_sites_posts,
            main_content: references_sites_posts,
          },
        },
        {
          path: 'notifications',
          name: 'notifications',
          beforeEnter: getMe,
          components: {
            default: push_notifications,
            main_content: push_notifications,
          },
        },
        {
          path: 'users/create',
          name: 'user_create',
          beforeEnter: getMe,
          components: {
            default: UserCreate,
            main_content: UserCreate,
          },
        },
        {
          path: 'users/edit/:id',
          name: 'user_edit',
          beforeEnter: getMe,
          components: {
            default: UserCreate,
            main_content: UserCreate,
          },
        },
        {
          path: 'sites',
          name: 'sites',
          beforeEnter: getMe,
          components: {
            default: sites,
            main_content: sites,
          },
        },
        {
          path: 'sites/:key',
          name: 'site_detail',
          beforeEnter: getMe,
          components: {
            default: SiteDetail,
            main_content: SiteDetail,
          },
        },
        {
          path: 'banners',
          name: 'banners',
          props: (route) => ({ site_key: route.params.site_key }),
          beforeEnter: getMe,
          components: {
            main_content: banner_index,
            banner: banner_list,
          },
          children: [
            {
              beforeEnter: getMe,
              path: '',
              components: { banner: banner_list },
            },
            {
              path: 'list',
              name: 'banners_list',
              beforeEnter: getMe,
              components: { banner: banner_list },
            },
            {
              path: 'create',
              name: 'banners_create',
              beforeEnter: getMe,
              components: { banner: banner_create_edit },
            },
            {
              path: ':id',
              name: 'banners_edit',
              beforeEnter: getMe,
              components: { banner: banner_create_edit },
            },
          ],
        },
        {
          path: 'press',
          name: 'press',
          props: (route) => ({ site_key: route.params.site_key }),
          beforeEnter: getMe,
          components: { main_content: press_index },
          children: [
            {
              path: '',
              beforeEnter: getMe,
              components: {
                main_contents: press_index,
                press: newspapers_index,
              },
            },
            {
              path: 'newspapers',
              name: 'newspapers_list',
              beforeEnter: getMe,
              components: {
                press: newspapers_index,
              },
            },
            {
              path: 'newspapers/create',
              name: 'newspapers_create',
              beforeEnter: getMe,
              components: {
                press: create_update,
              },
            },
            {
              path: 'newspapers/:id',
              name: 'newspapers_edit',
              beforeEnter: getMe,
              components: {
                press: create_update,
              },
            },
            {
              path: 'brochures',
              name: 'brochures_list',
              beforeEnter: getMe,
              components: {
                press: brochures_list,
              },
            },
            {
              path: 'brochures/create',
              name: 'brochures_create',
              beforeEnter: getMe,
              components: {
                press: brochures_edit,
              },
            },
            {
              path: 'brochures/:id',
              name: 'brochures_edit',
              beforeEnter: getMe,
              components: {
                press: brochures_edit,
              },
            },
            {
              path: 'magazines',
              name: 'magazines_list',
              beforeEnter: getMe,
              components: {
                press: magazines_index,
              },
            },

            {
              path: 'magazines/create',
              name: 'magazines_create',
              beforeEnter: getMe,
              components: {
                press: magazines_edit,
              },
            },
            {
              path: 'magazines/:id',
              name: 'magazines_edit',
              beforeEnter: getMe,
              components: {
                press: magazines_edit,
              },
            },
            {
              path: 'program-article',
              name: 'program_article_list',
              beforeEnter: getMe,
              components: {
                press: program_article_index,
              },
            },
            {
              path: 'program-article/create',
              name: 'program_article_create',
              beforeEnter: getMe,
              components: {
                press: program_article_edit,
              },
            },
            {
              path: 'program-article/:id',
              name: 'program_article_edit',
              beforeEnter: getMe,
              components: {
                press: program_article_edit,
              },
            },
          ],
        },
        {
          path: 'members',
          name: 'members',
          props: (route) => ({ site_key: route.params.site_key }),
          beforeEnter: getMe,
          components: { main_content: members_index },
          children: [
            {
              path: '',
              beforeEnter: getMe,
              components: {
                main_contents: members_index,
                members: members_list,
              },
            },
            {
              path: 'groups',
              name: 'members_groups',
              beforeEnter: getMe,
              components: {
                members: groups_list,
              },
            },
            {
              path: 'groups/:id',
              name: 'members_groups_edit',
              beforeEnter: getMe,
              components: {
                members: groups_create_edit,
              },
            },
            {
              path: 'groups/create',
              name: 'members_groups_create',
              beforeEnter: getMe,
              components: {
                members: groups_create_edit,
              },
            },
            {
              path: 'list',
              name: 'members_list',
              beforeEnter: getMe,
              components: {
                members: members_list,
              },
            },
            {
              path: 'create',
              name: 'members_create',
              beforeEnter: getMe,
              components: {
                members: members_create_edit,
              },
            },
            {
              path: ':id',
              name: 'members_edit',
              beforeEnter: getMe,
              components: {
                members: members_create_edit,
              },
            },
          ],
        },
        {
          path: 'party',
          name: 'party',
          beforeEnter: getMe,
          components: {
            default: party,
            main_content: party,
          },
          children: [
            {
              path: '',
              beforeEnter: getMe,
              components: { party: history },
            },
            {
              path: 'history',
              name: 'party_history_list',
              beforeEnter: getMe,
              components: { party: history },
            },
            {
              path: 'program',
              name: 'party_program_list',
              beforeEnter: getMe,
              components: {
                party: program,
              },
            },
          ],
        },
        {
          path: 'yasldpr',
          name: 'yasldpr',
          beforeEnter: getMe,
          components: {
            default: yasldpr,
            main_content: yasldpr,
          },
        },
        {
          path: 'vstupi',
          name: 'vstupi',
          beforeEnter: getMe,
          components: {
            default: vstupi,
            main_content: vstupi,
          },
        },
      ],
    },
  ],
})
